import React from "react";
import { Card, Col, Row, Skeleton, Space } from "antd";

export default function CommonSkeletonPage() {
  return (
    <div style={{ padding: "24px" }}>
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        {/* Primary action skeleton */}
        <Skeleton.Button active size="large" style={{ width: 120 }} />

        <Row gutter={24}>
          {/* Main content section */}
          <Col span={16}>
            <Space direction="vertical" size="middle" style={{ width: "100%" }}>
              <Card>
                <Skeleton active paragraph={{ rows: 3 }} />
              </Card>
              <Card>
                <Skeleton active paragraph={{ rows: 3 }} />
              </Card>
              <Card>
                <Skeleton active paragraph={{ rows: 3 }} />
              </Card>
              <Card>
                <Skeleton active paragraph={{ rows: 3 }} />
              </Card>
              <Card>
                <Skeleton active paragraph={{ rows: 3 }} />
              </Card>
            </Space>
          </Col>

          {/* Secondary section */}
          <Col span={8}>
            <Space direction="vertical" size="middle" style={{ width: "100%" }}>
              <Card>
                <Space direction="vertical" size="small" style={{ width: "100%" }}>
                  <Card size="small">
                    <Skeleton active paragraph={{ rows: 2 }} title={false} />
                  </Card>
                  <Card size="small">
                    <Skeleton active paragraph={{ rows: 1 }} title={false} />
                  </Card>
                </Space>
              </Card>

              <Card style={{ backgroundColor: "#fafafa" }}>
                <Space direction="vertical" size="small" style={{ width: "100%" }}>
                  <Card size="small">
                    <Skeleton active paragraph={{ rows: 2 }} title={false} />
                  </Card>
                  <Card size="small">
                    <Skeleton active paragraph={{ rows: 2 }} title={false} />
                  </Card>
                </Space>
              </Card>

              <Card style={{ backgroundColor: "#fafafa" }}>
                <Space direction="vertical" size="small" style={{ width: "100%" }}>
                  <Card size="small">
                    <Skeleton active paragraph={{ rows: 2 }} title={false} />
                  </Card>
                  <Card size="small">
                    <Skeleton active paragraph={{ rows: 2 }} title={false} />
                  </Card>
                </Space>
              </Card>

              <Card style={{ backgroundColor: "#fafafa" }}>
                <Space direction="vertical" size="small" style={{ width: "100%" }}>
                  <Card size="small">
                    <Skeleton active paragraph={{ rows: 2 }} title={false} />
                  </Card>
                  <Card size="small">
                    <Skeleton active paragraph={{ rows: 2 }} title={false} />
                  </Card>
                </Space>
              </Card>
            </Space>
          </Col>
        </Row>
      </Space>
    </div>
  );
}
